'use strict';

function MoneyUpDashboardHomeTrade() {
  var _this = this;

  this.id = null;
  this.node = null;
  this.declaredClass = null;
  this.extends = [_TradeController, _MoneyUpDashboardHomeBase];

  this.presenter = null;
  this.analytics = null;
  this.onComplete = function () {};

  this._classNames = {
    onWaitlist: MoneyUpProductCell.classNames.active,
    invitedNoAccount: MoneyUpProductCell.classNames.active,
    invitedAccount: MoneyUpProductCell.classNames.active,
    notOnWaitlist: MoneyUpProductCell.classNames.inactive
  };

  this._disclaimers = {
    /*
      
      Disclaimer is combination of 88 and 91 for all cases below
         88: Mogo Trade 
        
          - legalDisclaimer key 88 in app/content/snapshots/master/legalDisclaimer.json
         91: Canadian Investor Protection Fund (Mogo Trade)
           - legalDisclaimer key 91 in app/content/snapshots/master/legalDisclaimer.json
       
    */

    onWaitlist: {
      text: 'disclaimer.88_91'
    },
    invitedNoAccount: {
      text: 'disclaimer.88_91'
    },
    invitedAccount: {
      text: 'disclaimer.88_91'
    },
    notOnWaitlist: {
      text: 'disclaimer.88_91'
    }
  };

  this.init = function () {
    this._super();
    this._connectionIssueConfig = this._getConnectionIssueConfig();
  };

  this.initAllReady = function () {
    this._super();
    this.dialog = document.querySelector('#open-moka-dialog');

    function isMobile() {
      return (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)
      );
    }

    $('.dashboard-product--trade').click(function () {
      if (isMobile()) {
        var tradeAppLink = 'https://app.trade.mogo.ca/trade';
        window.open(tradeAppLink);
      } else if (!this.dialog) {
        $('<div></div>').mogo().create('Dialog', {
          id: 'open-trade-dialog',
          close: true,
          url: '/member/trade/get-trade-dialog', // Pug file containing markup for dialog
          onUrlLoaded: function onUrlLoaded() {
            document.querySelector('#open-trade-dialog').mogo().show();
          },

          backgroundClose: false
        });
        this.dialog = document.querySelector('#open-trade-dialog');
      } else {
        this.dialog.mogo().show();
      }
    });
  };

  this.initPage = function () {
    var cellSettings = {
      product: 'MogoTrade',
      classNameExtensions: this._classNames,
      contentExtensions: this._content,
      disclaimers: this._disclaimers
    };

    this._createProductCell(cellSettings);
    this.onComplete(); // tell page component is loaded
    $.when(this.presenter._contentLoadedPromise).then(this._setState.bind(this));
  };

  this._setState = function () {
    if (!_this.node.querySelector('.js--dashboard-product').mogo().create) {
      _this._productCell = _this._getProductCell();
      var productState = 'loading';
      var analyticsState = 'Loading';

      var notOnWaitlist = _this.presenter.models.tradeProfile.waitlist === null;

      var OnWaitlist = _this.presenter.models.tradeProfile.waitlist && _this.presenter.models.tradeProfile.waitlist.waitlisted_position !== null;

      var invitedNoAccount = _this.presenter.models.tradeProfile.waitlist && _this.presenter.models.tradeProfile.waitlist.invited_at !== null && _this.presenter.models.tradeProfile.trade_profile === null;

      var invitedAccount = _this.presenter.models.tradeProfile.trade_profile !== null;

      if (notOnWaitlist) {
        productState = 'notOnWaitlist';
        analyticsState = 'notOnWaitlist';
      } else if (invitedAccount) {
        productState = 'invitedAccount';
        analyticsState = 'invitedAccount';
      } else if (invitedNoAccount) {
        productState = 'invitedNoAccount';
        analyticsState = 'invitedNoAccount';
      } else if (OnWaitlist) {
        productState = 'onWaitlist';
        analyticsState = 'onWaitlist';
      }

      _this._productCell.setState(productState, analyticsState);
      _this._setAlertState(analyticsState);
    }
  };

  this._setAlertState = function () {
    var state = _this._productCell.getState();

    if (state === 'notOnWaitlist' || state === 'invitedAccount') {
      _this._productCell.showAlert(false);
    } else if (state === 'onWaitlist') {
      _this._productCell.showCustomAlertState();
    } else {
      _this._productCell.showAlert(true);
    }
  };

  this._getTradeNotOnWaitlistContentString = function () {
    return _this.presenter.getModelProperty('content.pages.MoneyUpDashboardHome.productTiles.tradeNotOnWaitlist.message');
  };

  this._getTradeOnWaitlistContentString = function () {
    var waitListPosition = _this.presenter.models.tradeProfile.waitlist.position;
    var message = _this.presenter.getModelProperty('content.pages.MoneyUpDashboardHome.productTiles.tradeOnWaitlist.message');
    return '<span class="waitlist-position--text">\n              ' + message + '\n            </span>\n            <span class="waitlist-position--number">\n              <span class="waitlist-position--small">#</span>\n              <span class="waitlist-position--large">\n                ' + waitListPosition.toLocaleString() + '\n              </span>\n            </span>';
  };

  this._getTradeInvitedNoAccountContentString = function () {
    return _this.presenter.getModelProperty('content.pages.MoneyUpDashboardHome.productTiles.tradeInvitedNoAccount.message');
  };

  this._getTradeInvitedAccountContentString = function () {
    return _this.presenter.getModelProperty('content.pages.MoneyUpDashboardHome.productTiles.tradeInvitedAccount.message');
  };

  // define after any methods that are referenced in definition
  this._content = {
    notOnWaitlist: this._getTradeNotOnWaitlistContentString,
    onWaitlist: this._getTradeOnWaitlistContentString,
    invitedNoAccount: this._getTradeInvitedNoAccountContentString,
    invitedAccount: this._getTradeInvitedAccountContentString
  };

  this.destroy = function () {
    this._super();
  };
}